import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const API_URL = API;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("raava_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && sessionStorage.getItem("raava_token")) {
      sessionStorage.removeItem("raava_token");
      window.dispatchEvent(new CustomEvent("raava:session-expired"));
    }
    return Promise.reject(error);
  },
);

export function formatKeyInput(value) {
  const chars = value.normalize("NFKC").toUpperCase().replace(/[^A-Z0-9]/g, "");
  const stripped = chars.startsWith("RAAVA") ? chars.slice(5) : chars;
  const body = stripped.slice(0, 16);
  if (!body) return "";
  const parts = [body.slice(0, 4), body.slice(4, 8), body.slice(8, 12), body.slice(12, 16)].filter(Boolean);
  return `RAAVA-${parts.join("-")}`;
}
